import axios from 'axios'

import { Env, getEnv } from '@cinch/oxd-utils/env/src'
import { queryString } from '@cinch/oxd-utils/requests/src'

const vehicle = axios.create({ baseURL: getEnv(Env.VehicleSearchServiceUrl) })

export interface Car {
  manufacturerName: string
  modelName?: string
}

export const getVehiclesByMakeAndModel = (car: Car) => {
  const { manufacturerName, modelName = '' } = car
  const params = {
    make: manufacturerName,
    selectedModel: modelName,
    pageSize: 6,
    sortingCriteria: 1,
  }

  return vehicle.request({
    url: `vehicles?${queryString(params)}`,
    method: 'GET',
  })
}
